/* eslint-disable import/first */
import Vue from 'vue';
import VueCompositionAPI from '@vue/composition-api';

Vue.use(VueCompositionAPI);

import 'bulma/css/bulma.css';

import hooks from '@u3u/vue-hooks';

Vue.use(hooks);

import App from './App.vue';
import router from './router';
import store from './store';

const VueTruncate = require('vue-truncate-filter');

Vue.use(VueTruncate);

const moment = require('moment');
require('moment/locale/hr');

Vue.use(require('vue-moment'), {
  moment,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
